module.exports = {
  id: 'contactForm',
  method: 'post',
  action: '/actions/futurium/forms/contact',
  cells: [
    {
      fieldType: 'input',
      name: 'title',
      modifier: 'half',
      label: 'Titel',
      placeholder: 'Titel'
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'firstName',
      label: 'Vorname',
      placeholder: 'Vorname',
      autocomplete: 'given-name',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'lastName',
      label: 'Nachname',
      placeholder: 'Nachname',
      autocomplete: 'family-name',
      required: true
    },
    {
      modifier: 'half',
      fieldType: 'input',
      name: 'email',
      type: 'email',
      label: 'E-Mail',
      placeholder: 'E-Mail',
      autocomplete: 'email',
      required: true
    },
    {
      fieldType: 'textarea',
      name: 'comments',
      label: 'Bemerkungen',
      placeholder: 'Bemerkungen'
    }
  ],
  submitText: 'Absenden'
};
